
export default {
    mainPageContent: {},
    rightSideLinks:{}
}
